
export default {
    mainPageContent: {},
    rightSideLinks:{}
}
